/**
 * Hides the labelling UI behind an explicit "Claim & start annotating"
 * CTA when the current user isn't already the assigned annotator. Stops
 * a user from labelling against a record / pass they don't own.
 */
import React from 'react';

import { Button } from '../../../../../ui/button';
import type { DatasetRecord } from '../../types';


interface Props {
  record: DatasetRecord;
  isClaiming: boolean;
  onClaim: () => void;
}


const ClaimGate: React.FC<Props> = ({ record, isClaiming, onClaim }) => {
  // Communicate which pass the claim will be for, so the user knows
  // what they're committing to before clicking.
  let passLabel = 'this record';
  if (record.status === 'pending') passLabel = 'this record for first-pass annotation';
  else if (record.status === 'annotated_first')
    passLabel = 'this record for second-pass annotation';

  return (
    <div
      className="flex min-h-0 flex-col items-start justify-center gap-4 rounded-2xl border bg-background p-6"
      data-testid="claim-gate"
    >
      <div className="space-y-1">
        <h2 className="font-jakarta text-lg font-extrabold tracking-[-0.02em] text-foreground">
          Ready to annotate?
        </h2>
        <p className="text-[13px] leading-[1.6] text-muted-foreground">
          You aren't currently assigned to {passLabel}. Click below to claim
          it — once claimed, the annotation flow will open and the record
          will appear in your queue.
        </p>
      </div>
      <Button
        onClick={onClaim}
        disabled={isClaiming}
        data-testid="claim-and-start"
      >
        {isClaiming ? 'Claiming…' : 'Claim & start annotating'}
      </Button>
    </div>
  );
};

export default ClaimGate;
